module.exports = __webpack_public_path__ + "static/media/English_British_Bruce BG-19.f4e79e3d.png";